import React, {useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Individual.css';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';

function Individual() {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // This will make it jump to the top without smooth scrolling
    });
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Individual Page' });
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Individual</title>
      </Helmet>
      <div className="blog-container">
        <h1 className="blog-header">Welcome to our Individual Tree Planting Program!</h1>
        <p className="blog-text">With your help, Blue Planet Ecosystem is transforming communities and helping to change the world!</p>
        <p className="blog-text">At Blue Planet Ecosystem, we believe that every individual can make a significant impact on the environment. Join our environmentally friendly tree planting program and be a part of the movement to create a more sustainable planet. Sign up today to receive your very own free tree and continue planting more for just $1 each!</p>
        <img src="/img/img/service-1.jpg" alt="" className="blog-img" />
        <h2 className="blog-highlight">Our Program Highlights:</h2>
        <div className="blog-section">
          <h5>Free Tree for Everyone:</h5>
          <p className="blog-text">We are committed to making a positive change accessible to all. Simply by signing up, we plant your first tree on your behalf. Then, as your heart and budget allow, help us continue to take steps towards a greener and healthier world with additional trees.</p>
        </div>
        <p className="blog-text" style={{color: 'green'}}>
        </p><h5>Affordable Additional Trees:</h5><p className="blog-text" style={{color: 'green'}}> We want to encourage our global community
          to plant as many trees as possible. Add more trees to your collection
          for $1 each. Each donation plants a mangrove, which is one of the most
          oxygen rich trees in the world. They pull considerable CO2 and grow
          reliably and sustainably, bringing health to rivers and restoring native
          life and local habitats for dozens of animals. This nominal fee ensures
          that you can easily expand your personal green space and make a lasting
          impact on the environment.
        </p>
        <h5> Diverse Tree Selection:</h5> <p className="blog-text" style={{color: 'green'}}>Choose from a wide variety of tree species to
          suit your preferences and the environment in your area. Whether you want
          fruit-bearing trees, flowering trees, or those that attract local
          wildlife, we've got you covered.
        </p>
        <h5> Track Your Impact:</h5><p className="blog-text" style={{color: 'green'}}> We provide you with regular updates on the growth and
          impact of the trees you plant. Witness the positive change you foster.
          Be proud of your contribution to a healthier planet. Login to your
          personal portal to check your status and progress.
        </p>
        <h5>Green Gifting:</h5><p className="blog-text" style={{color: 'green'}}> Our tree planting program also makes for a unique and
          thoughtful gift. Surprise your loved ones with a tree, and together, you
          can make a difference in the environment.
        </p>
        <h5>Carbon Footprint Reduction:</h5><p className="blog-text" style={{color: 'green'}}> Trees are nature's air purifiers. By
          planting more trees, you actively contribute to offsetting your carbon
          footprint and combatting climate change.
        </p>
        <p className="blog-text" style={{color: 'green'}}>
          Join the Blue Planet Ecosystem community today and embark on your journey
          towards a greener, more sustainable future. Together, we can plant a
          forest of positive change, one tree at a time.
        </p>
      </div>
      <Link className="btn btn-primary btn-lg" to="/site/signup" id='btn-signup'>Sign Up</Link>
    </div>

  );
}

export default Individual;